import axios, { AxiosError } from 'axios';
import { keepPreviousData, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IHousingObjectResponse } from '@/types';
import { GET_POPULAR_HOUSING_API_ENDPOINT } from '@/constants';

interface PopularHousingParams {
  forLastDays?: number;
  itemsLimit?: number;
  project?: boolean;
}

export const useGetPopularHousing = (
  params?: PopularHousingParams,
  options?: Partial<UseQueryOptions<IHousingObjectResponse[], AxiosError>>,
) => {
  return useQuery<IHousingObjectResponse[], AxiosError>({
    queryKey: options?.queryKey ?? ['popular-housing', params],
    queryFn: () => axios.get(GET_POPULAR_HOUSING_API_ENDPOINT, { params }).then((res) => res.data),
    placeholderData: keepPreviousData,
    ...options,
  });
};
